import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { type CountryProvincesResponse, MiscApi, RequestStrategyEnum, type WithSignal } from '@shared/api';

const getCountryProvincesEffect = createEffect(({ signal }: WithSignal = {}) => MiscApi.getCountryProvinces(signal));
const clearEvent = createEvent();

const $dataStore = createStore<CountryProvincesResponse>({})
  .on(getCountryProvincesEffect.done, (_, data) => data.result.data ?? {})
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getCountryProvincesEffect.pending, (_, data) => data)
  .on(getCountryProvincesEffect.fail, () => false)
  .on(getCountryProvincesEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getCountryProvincesEffect, () => null)
  // .on(getCountryProvincesEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getCountryProvincesEffect.fail, () => 'Something went wrong while fetching Country Provinces. Please try again.')
  .on(getCountryProvincesEffect.done, () => null)
  .reset(clearEvent);

export const $countryProvincesStore = {
  events: {
    getCountryProvinces: ApiUtils.wrapperApi(getCountryProvincesEffect, RequestStrategyEnum.Debounce).trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
